import { filter } from "lodash";
import { yodaOrdersConstants } from "../constants";
import config from "../../utils/globalConfig";
import { getLocalizedString } from "../../utils";

const ordersReducer = (
  state = {
    loading: false,
    orders: [],
    newOrderId: null,
    configuration: null,
    order: null,
    orderSent: false, // when sending an order will set to true in case everything is fine
    report: null,
    shippingCost: [],
    statusCode: null,
    totalReorder: 0,
    totalSwap: 0,
    totalShippingCost: 0,
    maxSwap: 0,
    statusdescription: "",
    showDebug: false,
    debugInfo: "",
  },
  action,
) => {
  let tmpArray = null;
  let tmpArray2 = null;
  let tmpArray3 = null;

  switch (action.type) {
    case yodaOrdersConstants.LOADING:
      return {
        ...state,
        loading: action.payload.loading,
      };

    case yodaOrdersConstants.GETALL_HEADER_REQUEST:
      return {
        ...state,
        loading: true,
        orders: [],
      };

    case yodaOrdersConstants.GETALL_HEADER_SUCCESS:
      return {
        ...state,
        orders: action.payload.orders,
        loading: false,
      };

    case yodaOrdersConstants.GETALL_HEADER_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaOrdersConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
        orders: [],
      };

    case yodaOrdersConstants.GETALL_SUCCESS:
      return {
        ...state,
        orders: action.payload.orders,
        loading: false,
      };

    case yodaOrdersConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaOrdersConstants.GETONE_REQUEST:
      return {
        ...state,
        // loading: true,
        order: null,
        orderDetails: [],
        orderRowDetails: [],
      };

    case yodaOrdersConstants.GETONE_SUCCESS:
      return {
        ...state,
        order: action.payload.order,
        // loading: false,
      };

    case yodaOrdersConstants.GETONE_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        order: null,
        // loading: false,
      };

    case yodaOrdersConstants.GET_DETAILS_REQUEST:
      return {
        ...state,
        //loading: true,
      };

    case yodaOrdersConstants.GET_DETAILS_SUCCESS:
      action.payload.order.results.forEach((e) => {
        e.id = e.id + "_" + e.sizeRowid;
      });
      action.payload.order.results = action.payload.order.results.filter(
        (f) => f.sizeRowid != null,
      );
      return {
        ...state,
        orderDetails: action.payload.order.results,
        //loading: false,
      };

    case yodaOrdersConstants.GET_DETAILS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        //loading: false,
      };

    case yodaOrdersConstants.GET_SILENT_DETAILS_REQUEST:
      return {
        ...state,
        //loading: true,
      };

    case yodaOrdersConstants.GET_SILENT_DETAILS_SUCCESS:
      action.payload.order.results.forEach((e) => {
        e.id = e.id + "_" + e.sizeRowid;
      });
      action.payload.order.results = action.payload.order.results.filter(
        (f) => f.sizeRowid != null,
      );
      return {
        ...state,
        orderDetails: action.payload.order.results,
        //loading: false,
      };

    case yodaOrdersConstants.GET_SILENT_DETAILS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        //loading: false,
      };

    case yodaOrdersConstants.GET_ROW_DETAILS_RESET:
      return {
        ...state,
        orderRowDetails: [],
      };

    case yodaOrdersConstants.GET_ROW_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        orderRowDetails: [],
      };

    case yodaOrdersConstants.GET_ROW_DETAILS_SUCCESS:
      if (config.CONCURRENT_ORDER_API) {
        tmpArray = { ...state.orderRowDetails };
        Object.keys(tmpArray).forEach((e) => {
          if (
            e.match(new RegExp(action.payload.order.id + ".*", "g")) !== null
          ) {
            delete tmpArray[e];
          }
        });

        if (
          action.payload.order.orderRowsDetail &&
          action.payload.order.orderRowsDetail.length > 0
        ) {
          let tmpFilteredRows = action.payload.order.orderRowsDetail.filter(
            (f) => f.quantity > 0,
          );
          let filteredRows = {};

          for (let index = 0; index < tmpFilteredRows.length; ++index) {
            filteredRows[
              action.payload.order.id + "_" + tmpFilteredRows[index].sizeRowId
            ] = { ...action.payload.order };
            filteredRows[
              action.payload.order.id + "_" + tmpFilteredRows[index].sizeRowId
            ].id =
              action.payload.order.id + "_" + tmpFilteredRows[index].sizeRowId;
            filteredRows[
              action.payload.order.id + "_" + tmpFilteredRows[index].sizeRowId
            ].price = tmpFilteredRows[index].price;
            filteredRows[
              action.payload.order.id + "_" + tmpFilteredRows[index].sizeRowId
            ].quantity = tmpFilteredRows[index].quantity;
            filteredRows[
              action.payload.order.id + "_" + tmpFilteredRows[index].sizeRowId
            ].currentQuantity = tmpFilteredRows[index].quantity;
            filteredRows[
              action.payload.order.id + "_" + tmpFilteredRows[index].sizeRowId
            ].orderRowsDetail = [tmpFilteredRows[index]];
            filteredRows[
              action.payload.order.id + "_" + tmpFilteredRows[index].sizeRowId
            ].sizeRowId = tmpFilteredRows[index].sizeRowId;
          }

          tmpArray = { ...tmpArray, ...filteredRows };
        }

        return {
          ...state,
          orderRowDetails: tmpArray,
          loading: false,
        };
      } else {
        tmpArray = { ...state.orderRowDetails };
        tmpArray[action.payload.order.id] = action.payload.order;

        if (tmpArray && tmpArray[action.payload.order.id] != null) {
          tmpArray[action.payload.order.id].sizeRowId =
            action.payload.order.orderRowsDetail.filter(
              (f) => f.quantity > 0,
            )[0]?.sizeRowId || null;
        }

        return {
          ...state,
          orderRowDetails: tmpArray,
          loading: false,
        };
      }

    case yodaOrdersConstants.GET_ROW_DETAILS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaOrdersConstants.CREATE_HEADER_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case yodaOrdersConstants.CREATE_HEADER_SUCCESS:
      return {
        ...state,
        orders: [...state.orders, action.payload.order],
        newOrderId: action.payload.order.id,
        orderRowDetails: [],
        orderDetails: [],
        loading: false,
      };

    case yodaOrdersConstants.CREATE_HEADER_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaOrdersConstants.ADD_ROW_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case yodaOrdersConstants.ADD_ROW_SUCCESS:
      tmpArray = { ...state.orderRowDetails };
      tmpArray[action.payload.order.id] = action.payload.order;

      tmpArray[action.payload.order.id].sizeRowId =
        action.payload.order.orderRowsDetail.filter(
          (f) => f.quantity > 0,
        )[0].sizeRowId;
      tmpArray2 = [...state.orderDetails, action.payload.order];

      if (action.payload.order.currentQuantity !== Number(action.payload.val)) {
        let maxQuantitySetted = "MAX_QUANTITY_SETTED";

        if (action.payload.order.customData.typeId === config.ORDER_TYPE_SWAP) {
          maxQuantitySetted = "MAX_QUANTITY_SETTED_SWAP";
        }

        dispatchEvent(
          new CustomEvent("numericPad" + action.payload.identifier, {
            bubbles: true,
            detail: {
              message: getLocalizedString(maxQuantitySetted),
              clearValues: true,
              quantity: action.payload.order.currentQuantity,
            },
          }),
        );
      }

      return {
        ...state,
        orderRowDetails: tmpArray,
        orderDetails: tmpArray2,
        loading: false,
      };

    case yodaOrdersConstants.ADD_ROW_FAILURE:
      dispatchEvent(
        new CustomEvent("numericPad" + action.payload.identifier, {
          bubbles: true,
          detail: {
            message: action.payload.error.message,
            clearValues: true,
            quantity: action.payload.val,
          },
        }),
      );

      return {
        ...state,
        //error: action.payload.error,
        loading: false,
      };

    case yodaOrdersConstants.CONCURRENT_UPDATE_ROW_SINGLE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case yodaOrdersConstants.CONCURRENT_UPDATE_ROW_AUTOCOMPLETE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case yodaOrdersConstants.CONCURRENT_UPDATE_ROW_SINGLE_REQUEST_END:
      return {
        ...state,
        loading: false,
      };

    case yodaOrdersConstants.CONCURRENT_UPDATE_ROW_AUTOCOMPLETE_REQUEST_END:
      return {
        ...state,
        loading: false,
      };

    case yodaOrdersConstants.CONCURRENT_UPDATE_ROW_SUCCESS_AUTOCANCELLED:
      action.payload.list
        .filter((el) => el)
        .forEach((obj) => {
          dispatchEvent(
            new CustomEvent("numericPad" + obj.identifier, {
              bubbles: true,
              detail: {
                clearValues: true,
                quantity: 0,
              },
            }),
          );
        });

      tmpArray = { ...state.orderRowDetails };
      Object.keys(state.orderRowDetails).forEach((key) => {
        if (key.split("_")[0] === String(action.payload.order.id)) {
          delete tmpArray[key];
        }
      });

      return {
        ...state,
        orderRowDetails: tmpArray,
      };

    case yodaOrdersConstants.CONCURRENT_UPDATE_ROW_SINGLE_SUCCESS:
      tmpArray = { ...state.orderRowDetails };
      Object.keys(tmpArray).forEach((e) => {
        if (e.match(new RegExp(action.payload.order.id + ".*", "g")) !== null) {
          delete tmpArray[e];
        }
      });

      let filteredRowsSingle = {};
      if (
        action.payload.order.orderRowsDetail &&
        action.payload.order.orderRowsDetail.length > 0
      ) {
        let tmpFilteredRows = action.payload.order.orderRowsDetail.filter(
          (f) => f.quantity > 0,
        );

        for (let index = 0; index < tmpFilteredRows.length; ++index) {
          filteredRowsSingle[
            action.payload.order.id + "_" + tmpFilteredRows[index].sizeRowId
          ] = { ...action.payload.order };
          filteredRowsSingle[
            action.payload.order.id + "_" + tmpFilteredRows[index].sizeRowId
          ].id =
            action.payload.order.id + "_" + tmpFilteredRows[index].sizeRowId;
          filteredRowsSingle[
            action.payload.order.id + "_" + tmpFilteredRows[index].sizeRowId
          ].price = tmpFilteredRows[index].price;
          filteredRowsSingle[
            action.payload.order.id + "_" + tmpFilteredRows[index].sizeRowId
          ].quantity = tmpFilteredRows[index].quantity;
          filteredRowsSingle[
            action.payload.order.id + "_" + tmpFilteredRows[index].sizeRowId
          ].currentQuantity = tmpFilteredRows[index].quantity;
          filteredRowsSingle[
            action.payload.order.id + "_" + tmpFilteredRows[index].sizeRowId
          ].orderRowsDetail = [tmpFilteredRows[index]];
          filteredRowsSingle[
            action.payload.order.id + "_" + tmpFilteredRows[index].sizeRowId
          ].sizeRowId = tmpFilteredRows[index].sizeRowId;

          if (
            action.payload.sizeCode == tmpFilteredRows[index].sizeRowId &&
            tmpFilteredRows[index].quantity != action.payload.val
          ) {
            let maxQuantitySetted = "MAX_QUANTITY_SETTED";

            if (
              action.payload.order.customData.typeId === config.ORDER_TYPE_SWAP
            ) {
              maxQuantitySetted = "MAX_QUANTITY_SETTED_SWAP";
            }

            dispatchEvent(
              new CustomEvent("numericPad" + action.payload.identifier, {
                bubbles: true,
                detail: {
                  message: getLocalizedString(maxQuantitySetted),
                  clearValues: true,
                  quantity: tmpFilteredRows[index].quantity,
                },
              }),
            );
          }
        }
      }

      tmpArray = { ...tmpArray, ...filteredRowsSingle };

      return {
        ...state,
        orderRowDetails: tmpArray,
      };

    case yodaOrdersConstants.CONCURRENT_UPDATE_ROW_AUTOCOMPLETE_SUCCESS:
      tmpArray = { ...state.orderRowDetails };
      Object.keys(tmpArray).forEach((e) => {
        if (e.match(new RegExp(action.payload.order.id + ".*", "g")) !== null) {
          delete tmpArray[e];
        }
      });

      const hit = [];
      let filteredRows = {};
      if (
        action.payload.order.orderRowsDetail &&
        action.payload.order.orderRowsDetail.length > 0
      ) {
        let tmpFilteredRows = action.payload.order.orderRowsDetail.filter(
          (f) => f.quantity > 0,
        );

        for (let index = 0; index < tmpFilteredRows.length; ++index) {
          const idOrder =
            action.payload.order.id + "_" + tmpFilteredRows[index].sizeRowId;
          const obj = action.payload.list.find(
            (el) => el && el.sizeCode === tmpFilteredRows[index].sizeRowId,
          );
          filteredRows[idOrder] = { ...action.payload.order };
          filteredRows[idOrder].customData = tmpFilteredRows[index].customData;
          filteredRows[idOrder].id = idOrder;
          filteredRows[idOrder].price = tmpFilteredRows[index].price;
          filteredRows[idOrder].quantity = tmpFilteredRows[index].quantity;
          filteredRows[idOrder].currentQuantity =
            tmpFilteredRows[index].quantity;
          filteredRows[idOrder].orderRowsDetail = [tmpFilteredRows[index]];
          filteredRows[idOrder].sizeRowId = tmpFilteredRows[index].sizeRowId;

          if (obj) {
            hit.push(obj.sizeCode);
            dispatchEvent(
              new CustomEvent("numericPad" + obj.identifier, {
                bubbles: true,
                detail: {
                  clearValues: true,
                  quantity: tmpFilteredRows[index].quantity,
                },
              }),
            );
          }
        }
      }

      const notAvailable = action.payload.list.filter(
        (el) => el && !hit.includes(el.sizeCode),
      );
      if (notAvailable.length > 0) {
        let maxQuantitySetted = "MAX_QUANTITY_SETTED";

        if (
          action.payload.order?.customData?.typeId === config.ORDER_TYPE_SWAP
        ) {
          maxQuantitySetted = "MAX_QUANTITY_SETTED_SWAP";
        }

        if (!action.payload.order?.orderRowsDetail?.length) {
          maxQuantitySetted = "MAX_QUANTITY_SETTED_NO_ALLOCATION";
        }

        dispatchEvent(
          new CustomEvent("numericPad" + notAvailable[0].identifier, {
            bubbles: true,
            detail: {
              message: getLocalizedString(maxQuantitySetted),
              clearValues: true,
              quantity: 0,
            },
          }),
        );
      }

      tmpArray = { ...tmpArray, ...filteredRows };
      return {
        ...state,
        orderRowDetails: tmpArray,
      };

    case yodaOrdersConstants.CONCURRENT_UPDATE_ROW_AUTOCOMPLETE_FAILURE:
      if (
        action.payload?.error?.message?.includes(
          "Nessuna disponibilità articolo in magazzino",
        ) ||
        action.payload?.error?.message?.includes(
          "Disponibilit\u00E0 gi\u00E0 allocata sulle altre door",
        )
      ) {
        action.payload.val = 0;
      }
      return {
        ...state,
        error: action.payload.error.message,
        loading: false,
      };

    case yodaOrdersConstants.CONCURRENT_UPDATE_ROW_AUTOCOMPLETE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case yodaOrdersConstants.CONCURRENT_UPDATE_ROW_SINGLE_FAILURE:
      if (
        action.payload?.error?.message?.includes(
          "Nessuna disponibilità articolo in magazzino",
        ) ||
        action.payload?.error?.message?.includes(
          "Disponibilit\u00E0 gi\u00E0 allocata sulle altre door",
        )
      ) {
        action.payload.val = 0;
      }
      dispatchEvent(
        new CustomEvent("numericPad" + action.payload.identifier, {
          bubbles: true,
          detail: {
            message: action.payload?.error?.message,
            clearValues: true,
            quantity: action.payload?.val,
          },
        }),
      );
      return {
        ...state,
        error: action.payload?.error?.message,
        loading: false,
      };

    case yodaOrdersConstants.UPDATE_ROW_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case yodaOrdersConstants.UPDATE_ROW_SUCCESS:
      tmpArray = { ...state.orderRowDetails };
      tmpArray[action.payload.order.id] = action.payload.order;

      tmpArray[action.payload.order.id].sizeRowId =
        action.payload.order.orderRowsDetail.filter(
          (f) => f.quantity > 0,
        )[0].sizeRowId;

      tmpArray2 = [
        ...state.orderDetails.filter((f) => f.id != action.payload.order.id),
      ];
      tmpArray2 = [...tmpArray2, action.payload.order];

      if (action.payload.order.currentQuantity !== Number(action.payload.val)) {
        let maxQuantitySetted = "MAX_QUANTITY_SETTED";

        if (action.payload.order.customData.typeId === config.ORDER_TYPE_SWAP) {
          maxQuantitySetted = "MAX_QUANTITY_SETTED_SWAP";
        }

        dispatchEvent(
          new CustomEvent("numericPad" + action.payload.identifier, {
            bubbles: true,
            detail: {
              message: getLocalizedString(maxQuantitySetted),
              clearValues: true,
              quantity: action.payload.order.currentQuantity,
            },
          }),
        );
      }

      return {
        ...state,
        orderRowDetails: tmpArray,
        orderDetails: tmpArray2,
        loading: false,
      };

    case yodaOrdersConstants.UPDATE_ROW_FAILURE:
      dispatchEvent(
        new CustomEvent("numericPad" + action.payload.identifier, {
          bubbles: true,
          detail: {
            message: action.payload.error.message,
            clearValues: true,
            quantity: action.payload.val,
          },
        }),
      );

      return {
        ...state,
        //error: action.payload.error,
        loading: false,
      };

    case yodaOrdersConstants.REMOVE_ROW_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case yodaOrdersConstants.REMOVE_ROW_SUCCESS:
      tmpArray2 = [...state.orderDetails];
      tmpArray2 = tmpArray2.filter((f) => f.id != action.payload.rowId);

      tmpArray = { ...state.orderRowDetails };
      tmpArray3 = {};
      Object.keys(tmpArray).forEach((k) => {
        let v = tmpArray[k];
        if (k != action.payload.rowId) {
          tmpArray3[k] = { ...v, id: Number(k) };
        }
      });

      return {
        ...state,
        orderDetails: tmpArray2,
        orderRowDetails: tmpArray3,
        //order: action.payload.order,
        loading: false,
      };

    case yodaOrdersConstants.REMOVE_ROW_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaOrdersConstants.CONFIRM_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case yodaOrdersConstants.CONFIRM_ORDER_SUCCESS:
      return {
        ...state,
        order: action.payload.order,
        loading: false,
      };

    case yodaOrdersConstants.CONFIRM_ORDER_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaOrdersConstants.REMOVE_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case yodaOrdersConstants.REMOVE_ORDER_SUCCESS:
      return {
        ...state,
        orders: [...state.orders.filter((o) => o.id !== action.payload.id)],
        loading: false,
      };

    case yodaOrdersConstants.REMOVE_ORDER_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaOrdersConstants.CONFIGURATION_ORDER_REQUEST:
      return {
        ...state,
        configuration: null,
        //loading: true,
      };

    case yodaOrdersConstants.CONFIGURATION_ORDER_SUCCESS:
      return {
        ...state,
        configuration: action.payload.configuration,
        //loading: false,
      };

    case yodaOrdersConstants.CONFIGURATION_ORDER_FAILURE:
      return {
        ...state,
        configuration: null,
        error: action.payload.error,
        //loading: false,
      };

    case yodaOrdersConstants.ORDER_ID_RESET:
      return {
        ...state,
        newOrderId: null,
      };

    case yodaOrdersConstants.SWITCH_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case yodaOrdersConstants.SWITCH_TYPE_SUCCESS:
      let tmpOrder = { ...state.order };
      tmpOrder.orderTypeId =
        tmpOrder.orderTypeId == config.ORDER_TYPE_REORDER
          ? config.ORDER_TYPE_SWAP
          : config.ORDER_TYPE_REORDER;

      tmpArray = { ...state.orderRowDetails };
      if (tmpOrder.orderTypeId === config.ORDER_TYPE_REORDER) {
        let a = filter(
          tmpArray,
          (k, v) => k.customData.typeId == config.ORDER_TYPE_SWAP,
        );

        for (let element in a) {
          element = a[element];
          let id = element.id;
          delete tmpArray[id];
        }
      }

      return {
        ...state,
        loading: false,
        order: tmpOrder,
        orderRowDetails: tmpArray || {},
      };

    case yodaOrdersConstants.SWITCH_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
      };

    case yodaOrdersConstants.GETALL_ADMIN_DRAFT_REQUEST:
      return {
        ...state,
        loading: true,
        //orders: []
      };

    case yodaOrdersConstants.GETALL_ADMIN_DRAFT_SUCCESS:
      return {
        ...state,
        orders: action.payload.orders,
        loading: false,
      };

    case yodaOrdersConstants.GETALL_ADMIN_DRAFT_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaOrdersConstants.WAITING_FOR_CONFIRMATION_REQUEST:
      return {
        ...state,
        loading: true,
        //orders: []
      };

    case yodaOrdersConstants.WAITING_FOR_CONFIRMATION_SUCCESS:
      return {
        ...state,
        order: action.payload.order,
        loading: false,
      };

    case yodaOrdersConstants.WAITING_FOR_CONFIRMATION_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaOrdersConstants.TRANSMIT_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        //orders: []
      };

    case yodaOrdersConstants.TRANSMIT_ORDER_SUCCESS:
      return {
        ...state,
        order: action.payload.order,
        loading: false,
      };

    case yodaOrdersConstants.TRANSMIT_ORDER_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaOrdersConstants.RESET_ERROR:
      return {
        ...state,
        error: null,
        loading: false,
      };

    case yodaOrdersConstants.RESET_ORDER:
      return {
        ...state,
        orderRowDetails: [],
        orderDetails: [],
        order: null,
        loading: false,
      };

    case yodaOrdersConstants.REMOVE_PRODUCT_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case yodaOrdersConstants.REMOVE_PRODUCT_SUCCESS:
      const newOrderRowDetails = { ...state.orderRowDetails };
      let modelRows = filter(newOrderRowDetails, (orderItem) => {
        return (
          orderItem?.fullCode?.match?.("_" + action.payload.modelCode + "_") &&
          orderItem?.customData?.typeId === action.payload.rowTypeId
        );
      });

      if (action.payload.colorCode) {
        let b = modelRows.filter(
          (f) => f.fullCode.match("_" + action.payload.colorCode) !== null,
        );
        for (let element in b) {
          element = b[element];
          let id = element.id;
          delete newOrderRowDetails[id];
        }
      } else {
        for (let element in modelRows) {
          element = modelRows[element];
          let id = element.id;
          delete newOrderRowDetails[id];
        }
      }

      return {
        ...state,
        orderRowDetails: newOrderRowDetails,
        loading: false,
      };

    case yodaOrdersConstants.REMOVE_PRODUCT_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaOrdersConstants.GENERATE_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        report: null,
      };

    case yodaOrdersConstants.GENERATE_REPORT_SUCCESS:
      return {
        ...state,
        report: action.payload.report,
        loading: false,
      };

    case yodaOrdersConstants.GENERATE_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        report: null,
      };

    case yodaOrdersConstants.GET_ORDER_SHIPPING_COST_REQUEST:
      return {
        ...state,
        report: null,
      };

    case yodaOrdersConstants.GET_ORDER_SHIPPING_COST_SUCCESS:
      return {
        ...state,
        shippingCost: action.payload.shippingCost,
      };

    case yodaOrdersConstants.GET_ORDER_SHIPPING_COST_FAILURE:
      return {
        ...state,
        report: null,
      };

    case yodaOrdersConstants.GET_STATUS_ORDER_REQUEST:
      return {
        ...state,
      };

    case yodaOrdersConstants.GET_STATUS_ORDER_REQUEST_SUCCESS:
      return {
        ...state,
        statusCode: action.payload.code,
        totalReorder: action.payload.totalReorder,
        totalSwap: action.payload.totalSwap,
        totalShippingCost: action.payload.totalShippingCost,
        maxSwap: action.payload.maxSwap,
        showDebug: action.payload.showDebug,
        debugInfo: action.payload.debugInfo,
        statusdescription: action.payload.description,
      };

    case yodaOrdersConstants.GET_STATUS_ORDER_REQUEST_FAILURE:
      return {
        ...state,
      };

    default:
      return state;
  }
};

export default ordersReducer;
